const PREFIX = 'USERS_';

export const SEARCH_USER_BY_EMAIL_REQUEST = `${PREFIX}SEARCH_USER_BY_EMAIL_REQUEST`;
export const SEARCH_USER_BY_EMAIL_SUCCESS = `${PREFIX}SEARCH_USER_BY_EMAIL_SUCCESS`;
export const SEARCH_USER_BY_EMAIL_ERROR = `${PREFIX}SEARCH_USER_BY_EMAIL_ERROR`;

export const GET_ORGS_BY_USER_EMAIL = `${PREFIX}GET_ORGS_BY_USER_EMAIL`;
